"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.applyTranslation = exports.getTranslateableFields = exports.localizedType = void 0;
const traverse_1 = __importDefault(require("traverse"));
const omit_1 = __importDefault(require("lodash/omit"));
const unescape_1 = __importDefault(require("lodash/unescape"));
const set_1 = __importDefault(require("lodash/set"));
const get_1 = __importDefault(require("lodash/get"));
exports.localizedType = '@builder.io/core:LocalizedValue';
function unescapeStringOrObject(input) {
    // Check if input is a string
    if (typeof input === 'string') {
        return unescape_1.default(input);
    }
    // Check if input is an object
    if (typeof input === 'object' && input !== null) {
        Object.keys(input).forEach(key => {
            if (typeof input[key] === 'string') {
                input[key] = unescape_1.default(input[key]);
            }
        });
        return input;
    }
    // Return input as is if it's neither a string nor an object
    return input;
}
function recordValue({ results, value, path, instructions, sourceLocaleId, }) {
    if (Array.isArray(value)) {
        value.forEach((item, index) => {
            recordValue({
                results,
                value: item,
                path: `${path}[${index}]`,
                instructions,
                sourceLocaleId,
            });
        });
    }
    else if (typeof value === 'object') {
        if (value['@type'] === exports.localizedType) {
            results[path] = {
                value: (value === null || value === void 0 ? void 0 : value[sourceLocaleId]) || (value === null || value === void 0 ? void 0 : value.Default),
                instructions,
            };
        }
        else {
            Object.entries(value).forEach(([key, v]) => {
                recordValue({
                    results,
                    value: v,
                    path: `${path}.${key}`,
                    instructions,
                    sourceLocaleId,
                });
            });
        }
    }
}
function resolveTranslation({ data, basePath, path, value, translation, transformedMeta, locale, }) {
    if (Array.isArray(value)) {
        value.forEach((item, index) => {
            resolveTranslation({
                data,
                basePath,
                path: `${path}[${index}]`,
                value: item,
                translation,
                transformedMeta,
                locale,
            });
        });
    }
    else if (typeof value === 'object') {
        if (value['@type'] === exports.localizedType) {
            const translatedSymbolInput = translation[`${basePath}${path}`];
            if (!(translatedSymbolInput === null || translatedSymbolInput === void 0 ? void 0 : translatedSymbolInput.value)) {
                return;
            }
            set_1.default(data, path, Object.assign(Object.assign({}, value), { [locale]: unescapeStringOrObject(translatedSymbolInput.value) }));
            transformedMeta[`transformed.symbol.data.${path}`] = 'localized';
        }
        else {
            Object.entries(value).forEach(([key, v]) => {
                resolveTranslation({
                    data,
                    basePath,
                    path: `${path}.${key}`,
                    value: v,
                    translation,
                    transformedMeta,
                    locale,
                });
            });
        }
    }
}
function getTranslateableFields(content, sourceLocaleId, defaultInstructions) {
    const results = {};
    let _a = content.data, { blocks, blocksString, state } = _a, customFields = __rest(_a, ["blocks", "blocksString", "state"]);
    // metadata [content's localized custom fields]
    traverse_1.default(customFields).forEach(function (el) {
        var _a;
        if (this.key && el && el['@type'] === exports.localizedType) {
            results[`metadata.${this.path.join('#')}`] = {
                instructions: ((_a = el.meta) === null || _a === void 0 ? void 0 : _a.instructions) || defaultInstructions,
                value: el[sourceLocaleId] || el.Default,
            };
        }
    });
    if (blocksString && typeof blocks === 'undefined') {
        blocks = JSON.parse(blocksString);
    }
    // blocks
    if (blocks) {
        traverse_1.default(blocks).forEach(function (el) {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            if (this.key && el && ((_a = el.meta) === null || _a === void 0 ? void 0 : _a.localizedTextInputs)) {
                const localizedTextInputs = el.meta.localizedTextInputs;
                if (localizedTextInputs && Array.isArray(localizedTextInputs)) {
                    localizedTextInputs
                        .filter(input => { var _a; return get_1.default(((_a = el.component) === null || _a === void 0 ? void 0 : _a.options) || {}, `${input}.@type`) === exports.localizedType; })
                        .forEach(inputKey => {
                        var _a, _b;
                        const inputValue = get_1.default(((_a = el.component) === null || _a === void 0 ? void 0 : _a.options) || {}, inputKey);
                        const valueToBeTranslated = (inputValue === null || inputValue === void 0 ? void 0 : inputValue[sourceLocaleId]) || (inputValue === null || inputValue === void 0 ? void 0 : inputValue.Default);
                        if (valueToBeTranslated) {
                            results[`blocks.${el.id}#${inputKey}`] = {
                                instructions: ((_b = el.meta) === null || _b === void 0 ? void 0 : _b.instructions) || defaultInstructions,
                                value: valueToBeTranslated,
                            };
                        }
                    });
                }
            }
            if (el && el.id && ((_b = el.component) === null || _b === void 0 ? void 0 : _b.name) === 'Text' && !((_c = el.meta) === null || _c === void 0 ? void 0 : _c.excludeFromTranslation)) {
                const componentText = el.component.options.text;
                results[`blocks.${el.id}#text`] = {
                    value: typeof componentText === 'string'
                        ? componentText
                        : (componentText === null || componentText === void 0 ? void 0 : componentText[sourceLocaleId]) || (componentText === null || componentText === void 0 ? void 0 : componentText.Default),
                    instructions: ((_d = el.meta) === null || _d === void 0 ? void 0 : _d.instructions) || defaultInstructions,
                };
            }
            if (el && el.id && ((_e = el.component) === null || _e === void 0 ? void 0 : _e.name) === 'Symbol') {
                const symbolInputs = Object.entries((_h = (_g = (_f = el.component) === null || _f === void 0 ? void 0 : _f.options) === null || _g === void 0 ? void 0 : _g.symbol) === null || _h === void 0 ? void 0 : _h.data) || [];
                if (symbolInputs.length) {
                    const basePath = `blocks.${el.id}.symbolInput`;
                    symbolInputs.forEach(([symbolInputName, symbolInputValue]) => {
                        var _a;
                        if (symbolInputName === 'children') {
                            return;
                        }
                        recordValue({
                            results,
                            value: symbolInputValue,
                            path: `${basePath}#${symbolInputName}`,
                            instructions: ((_a = el.meta) === null || _a === void 0 ? void 0 : _a.instructions) || defaultInstructions,
                            sourceLocaleId,
                        });
                    });
                }
            }
        });
    }
    return results;
}
exports.getTranslateableFields = getTranslateableFields;
function applyTranslation(content, translation, locale) {
    let _a = content.data, { blocks, blocksString, state } = _a, customFields = __rest(_a, ["blocks", "blocksString", "state"]);
    traverse_1.default(customFields).forEach(function (el) {
        var _a;
        const path = (_a = this.path) === null || _a === void 0 ? void 0 : _a.join('#');
        if (translation[`metadata.${path}`]) {
            this.update(Object.assign(Object.assign({}, el), { [locale]: unescapeStringOrObject(translation[`metadata.${path}`].value) }));
        }
    });
    if (blocksString && typeof blocks === 'undefined') {
        blocks = JSON.parse(blocksString);
    }
    if (blocks) {
        traverse_1.default(blocks).forEach(function (el) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j;
            if (el && el.id && ((_a = el.component) === null || _a === void 0 ? void 0 : _a.name) === 'Symbol') {
                const symbolInputs = Object.entries((_d = (_c = (_b = el.component) === null || _b === void 0 ? void 0 : _b.options) === null || _c === void 0 ? void 0 : _c.symbol) === null || _d === void 0 ? void 0 : _d.data) || [];
                if (symbolInputs.length) {
                    const transformedMeta = {};
                    symbolInputs.forEach(([symbolInputName, symbolInputValue]) => {
                        var _a, _b, _c, _d;
                        resolveTranslation({
                            data: (_c = (_b = (_a = el.component) === null || _a === void 0 ? void 0 : _a.options) === null || _b === void 0 ? void 0 : _b.symbol) === null || _c === void 0 ? void 0 : _c.data,
                            basePath: `blocks.${el.id}.symbolInput#`,
                            path: symbolInputName,
                            value: symbolInputValue,
                            translation,
                            transformedMeta,
                            locale,
                        });
                        this.update(Object.assign(Object.assign({}, el), { meta: Object.assign(Object.assign(Object.assign({}, el.meta), { translated: true }), transformedMeta), component: Object.assign(Object.assign({}, el.component), { options: Object.assign(Object.assign({}, (el.component.options || {})), { symbol: Object.assign(Object.assign({}, (el.component.options.symbol || {})), { data: Object.assign({}, (((_d = el.component.options.symbol) === null || _d === void 0 ? void 0 : _d.data) || {})) }) }) }) }));
                    });
                }
            }
            if (el &&
                el.id &&
                ((_e = el.component) === null || _e === void 0 ? void 0 : _e.name) === 'Text' &&
                !((_f = el.meta) === null || _f === void 0 ? void 0 : _f.excludeFromTranslation) &&
                translation[`blocks.${el.id}#text`]) {
                const localizedValues = typeof ((_g = el.component.options) === null || _g === void 0 ? void 0 : _g.text) === 'string'
                    ? {
                        Default: el.component.options.text,
                    }
                    : el.component.options.text;
                this.update(Object.assign(Object.assign({}, el), { meta: Object.assign(Object.assign({}, el.meta), { translated: true, 
                        // this tells the editor that this is a forced localized input similar to clicking the globe icon
                        'transformed.text': 'localized' }), component: Object.assign(Object.assign({}, el.component), { options: Object.assign(Object.assign({}, el.component.options), { text: Object.assign(Object.assign({ '@type': exports.localizedType }, localizedValues), { [locale]: unescapeStringOrObject(translation[`blocks.${el.id}#text`].value) }) }) }) }));
            }
            // custom components
            if (el && el.id && ((_h = el.meta) === null || _h === void 0 ? void 0 : _h.localizedTextInputs)) {
                // there's a localized input
                const keys = (_j = el.meta) === null || _j === void 0 ? void 0 : _j.localizedTextInputs;
                let options = el.component.options;
                keys.forEach(key => {
                    if (translation[`blocks.${el.id}#${key}`]) {
                        set_1.default(options, key, Object.assign(Object.assign({}, (get_1.default(options, key) || {})), { [locale]: unescapeStringOrObject(translation[`blocks.${el.id}#${key}`].value) }));
                        this.update(Object.assign(Object.assign({}, el), { meta: Object.assign(Object.assign({}, el.meta), { translated: true }), component: Object.assign(Object.assign({}, el.component), { options }) }));
                    }
                });
            }
        });
        content.data = Object.assign(Object.assign({}, omit_1.default(content.data, 'blocksString')), { blocks });
    }
    content.data = Object.assign(Object.assign({}, content.data), customFields);
    return content;
}
exports.applyTranslation = applyTranslation;
